/**
 * Obsługa modala "Powiadom mnie o pytaniach"
 * subskrypcja uzytkownika
 * @type module
 */
app.service('notice', function (loading, validate, productCardConfig, modal, captchaService) {

	function letMeSuccess(){
		attachNotificationCaptcha();
		validate.task('notice',function(form){
			form.addClass('loading');
			letMe($('#notice').val());
		});
	}
	function letMe(email){
		email = email || '';
		var that=this;
		loading.start();
		$.ajax({
			url:'/productQuestionsNotificationSubscription.ltr',
			data:{
				email:email,
				productId:productCardConfig.getData().id,
				"g-recaptcha-response": $('#notice-form').find("#g-recaptcha-response").val() || ""
			},
			success:function(html){
				if($('<div>'+html+'</div>').find('form').length){
					modal.generate({
						header: 'Powiadom mnie o pytaniach do towaru',
						id:'notice-modal',
						content:html,
						callbackOpen:function(){
							letMeSuccess();
						}
					});
				}else{
					modal.alert(html);
				}
			},
			complete:function(){
				loading.stop();
			},
			error:function(){
				modal.alert('Błąd komunikacji, prosimy spróbować później');
			}
		});
	}

	function attachNotificationCaptcha() {
		const $captcha = $('#notice-modal').find('[data-toggle="captcha"]');
		if ($captcha.length) {
			captchaService.load($captcha.attr('id'), $captcha.data('place'));
		}
	}

	return {
		letMe:letMe
	};
});
